//https://adrianarlett.gitbooks.io/idiomatic-redux-by-dan-abramov/content/persisting-the-state-to-the-local-storage.html

/*
The loadState function is going to look into localStorage by key, retrieve a string, and try to parse it as JSON.
This code needs to be wrapped into a try/catch because it's possible that the user's browser disallows usage of the localStorage API.
In our loadState function, if the serializedState is null, it means that the key doesn't exist, so we return undefined which lets the reducers set the state instead.
However, if the serializedState string exists, we'll use JSON.parse(serializedState) in order to return it into the state object.
*/
export const loadState = (key = 'state') => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

/*
Our saveState function accepts our state as an argument, and does the exact opposite thing as our loadState function.
First, we use JSON.stringify(state) to serialize our state to a string. This will only work if the state is serializable,
but if you're following suggested Redux practices, you'll be good to go.
We catch any errors, since either JSON.stringify() or localStorage.setItem() can fail.
*/
export const saveState = (key = 'state', state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};



// WEBPACK FOOTER //
// ./src/utils/localStorage.js